"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleLoggerErrors = exports.loggedUnknownErrors = exports.STRINGS_TO_REACT = void 0;
var katal_logger_1 = require("@amzn/katal-logger");
var consts_1 = require("../../consts");
var logger_web_1 = require("../logger.web");
var getLogLevel_1 = require("../getLogLevel");
exports.STRINGS_TO_REACT = ['Minified React error'];
exports.loggedUnknownErrors = {};
var handleLoggerErrors = function (error) {
    var isErrorWithUnknownErrorMessage = (error === null || error === void 0 ? void 0 : error.message) === 'Unknown error';
    if (!!(error === null || error === void 0 ? void 0 : error.message) && !isErrorWithUnknownErrorMessage) {
        var lastMatchingErrorTimestamp = exports.loggedUnknownErrors[error.message];
        var logLevel = (0, getLogLevel_1.getLogLevel)(error, lastMatchingErrorTimestamp);
        var shouldLogErrorAsReact = error.stack
            ? exports.STRINGS_TO_REACT.some(function (reactString) { var _a; return (_a = error.stack) === null || _a === void 0 ? void 0 : _a.includes(reactString); })
            : false;
        if (!shouldLogErrorAsReact) {
            // eslint-disable-next-line no-restricted-globals
            exports.loggedUnknownErrors[error.message] = Date.now();
        }
        if (logLevel === katal_logger_1.Level.WARN) {
            logger_web_1.logger.emitCountMetric({
                metricName: consts_1.METRIC_NAME.APP_WARN_UNKNOWN
            });
            logger_web_1.logger.warn(error.message, {
                error: error,
                errorStackTrace: error.stack,
                isCaught: false,
                errorContext: consts_1.ERROR_CONTEXT.APPLICATION
            });
        }
        else {
            logger_web_1.logger.emitCountMetric({
                metricName: shouldLogErrorAsReact
                    ? consts_1.METRIC_NAME.APP_ERROR_REACT
                    : consts_1.METRIC_NAME.APP_ERROR_UNKNOWN
            });
            logger_web_1.logger.error(error.message, error, {
                isCaught: false,
                errorContext: consts_1.ERROR_CONTEXT.APPLICATION
            });
        }
    }
    // Prevent Katal from logging automatically to prevent redundant logs
    return isErrorWithUnknownErrorMessage;
};
exports.handleLoggerErrors = handleLoggerErrors;
